module.exports = __webpack_public_path__ + "img/humor.3a535db1.svg";